import axios from "axios";
import { API_BASE_URL } from "../../utils/config";

const createDefaultPrices = async (user, branchId, customerType) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}price/${branchId}`,
      {
        customerType: customerType,
      },
      {
        headers: {
          Authorization: `Bearer ${await user.getIdToken()}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating default prices:", error);
    console.error("Error details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url,
    });
    throw error;
  }
};

export default createDefaultPrices;
